import React from 'react';
import PropTypes from 'prop-types';
import Select from '../select/Select';
import './GuestSelector.scss';

const GuestSelector = ({
  maxNumOfGuests = 1,
  isClashedEvent,
  setNumberOfGuests,
  selectedNumberOfGuests,
}) => {
  const options = [...Array(maxNumOfGuests).keys()].map(i => ({ key: i + 1, value: i + 1 }));

  return (
    <div className="guest-selector-modal">
      <div className="guest-selector-modal-container">
        <div className="message">
          How many of your party would like to attend this session?
        </div>
        <div className="messageperperson">
          This venue is bookable per person - you must select the total number of people in your party.
          <div className="bold"> Please note: A table is not guaranteed. </div>
          You will either be sat on a table with up to five guests (note, this could be with other guests outside of your party) or in theatre style seating.
        </div>
        {isClashedEvent && <div className="message smaller">Please note that this new session overlaps with another booking that you already have.</div>}
        <Select options={options} onCheck={({ target = {} }) => setNumberOfGuests(target.value)} checked={selectedNumberOfGuests} />
      </div>
    </div>
  );
};

GuestSelector.propTypes = {
  maxNumOfGuests: PropTypes.number.isRequired,
  isClashedEvent: PropTypes.bool.isRequired,
  setNumberOfGuests: PropTypes.func,
  selectedNumberOfGuests: PropTypes.number,
};

export default GuestSelector;
